/**
 * @generated SignedSource<<63e7b706f95ddc2f7d52e0ef8e5f8332>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Privacy = "FriendsOnly" | "Public" | "%future added value";
export type EndUserUserInput = {
  avatarIndex?: number | null;
  email?: string | null;
  groupLastViewedAt?: any | null;
  name?: string | null;
  notificationsCursor?: string | null;
  password?: string | null;
  profilePrivacy?: Privacy | null;
  settings?: string | null;
  socialLastViewedAt?: any | null;
  username?: string | null;
  usernameID?: string | null;
};
export type useUserEditMutation$variables = {
  ID: string;
  input: EndUserUserInput;
};
export type useUserEditMutation$data = {
  readonly updateUser: {
    readonly " $fragmentSpreads": FragmentRefs<"PuzzmoCurrentUserFragment">;
  } | null;
};
export type useUserEditMutation = {
  response: useUserEditMutation$data;
  variables: useUserEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ID"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarURL",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usernameID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PuzzmoCurrentUserFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nakamaID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationsCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "settings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profilePrivacy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "friendNakamaIDs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HasMessages",
            "kind": "LinkedField",
            "name": "hasMessages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friends",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groups",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f69d14df79315acbf7fe10e5d34e091a",
    "id": null,
    "metadata": {},
    "name": "useUserEditMutation",
    "operationKind": "mutation",
    "text": "mutation useUserEditMutation(\n  $ID: ID!\n  $input: EndUserUserInput!\n) {\n  updateUser(id: $ID, input: $input) {\n    ...PuzzmoCurrentUserFragment\n    id\n  }\n}\n\nfragment PuzzmoCurrentUserFragment on User {\n  id\n  type\n  accounts {\n    id\n    email\n    users {\n      id\n      avatarURL\n      name\n      username\n      usernameID\n    }\n  }\n  roles\n  username\n  usernameID\n  avatarURL\n  name\n  nakamaID\n  notificationsCursor\n  settings\n  profilePrivacy\n  friendNakamaIDs\n  hasMessages {\n    friends\n    groups\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fb2852d092d718179fafa4f84004542";

export default node;
